/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Hidefilter1Inputs */

const de__filter_hidefilter1 = /** @type {(inputs: _Filter_Hidefilter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter ausblenden`)
};

/**

* @param {_Filter_Hidefilter1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_hidefilter1 = /** @type {((inputs?: _Filter_Hidefilter1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Hidefilter1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__filter_hidefilter1(inputs)
});
export { _filter_hidefilter1 as "_filter_hideFilter" }